import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useState } from 'react'
import { Link } from "react-router-dom";
import api from "../axiosConfig";
import Modal from 'bootstrap/js/dist/modal';
import PortalLogo from './utils/PortalLogo';

const ForgotPasswordLayer = () => {
  const [rfc, setRfc] = useState("");
  const [mail, setMail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // 👈 Estado para bloquear botón

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setError("");
    setLoading(true); // 👈 Activa loading

    try {
      const res = await api.post("/recuperaPass", {
        username: rfc,
        mail: mail
      });

      if (res.status === 200) {
        const myModal = new Modal(document.getElementById("exampleModal"));
        myModal.show(); // 👈 Abre modal
        setRfc("");
        setMail("");
      } else {
        setError("Sin coincidencia en la base de datos, si el problema continua contacte con el administrador.");
      }
    } catch (err) {
      console.error("Error en login:", err);
      setError("Sin coincidencia en la base de datos, si el problema continua contacte con el administrador.");
    } finally {
      setLoading(false); // 👈 Desactiva loading
    }
  };

  return (
    <>
      <section className="auth forgot-password-page bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="assets/images/auth/forgot-pass-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div>
              <div className=" text-center mb-5">
                <div className="row">
                  <div className='col-md-4'></div>
                  <div className='col-md-4'>
                    <div className="mb-3">
                      <PortalLogo />
                    </div>
                  </div>
                  <div className='col-md-4'></div>
                </div>
                <h4 className='mb-5 text-primary-600'>Portal del Trabajador</h4>
              </div>

              <h5 className='mb-12'>Recuperar Contraseña</h5>
              <p className="mb-32 text-secondary-light text-lg">
                Introduce la dirección de correo electrónico asociada a tu cuenta y te enviaremos un enlace para restablecer tu contraseña.
              </p>

              {error && (
                <div className='alert alert-danger text-sm mb-16'>{error}</div>
              )}
            </div>

            <form onSubmit={handleSubmit}>
              <div className='icon-field mb-16'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='mage:user-square' />
                </span>
                <input
                  type='text'
                  className='form-control h-56-px bg-neutral radius-12'
                  placeholder='RFC'
                  value={rfc}
                  onChange={(e) => setRfc(e.target.value)}
                  required
                  maxLength={13}
                  minLength={12}
                />
              </div>

              <div className="icon-field mb-20">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="mage:email" />
                </span>
                <input
                  type="email"
                  className="form-control h-56-px bg-neutral radius-12"
                  placeholder="Correo Electrónico"
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                  required
                  maxLength={150}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary-50 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                disabled={loading} // 👈 Botón bloqueado
              >
                {loading ? "Enviando..." : "Recuperar"}
              </button>

              <div className="text-center">
                <Link to="/" className="text-primary-600 fw-bold mt-24">
                  Regresar al Inicio de Sesión
                </Link>
              </div>
              <div className="mt-120 text-center text-sm">
                <p className="mb-0">
                  ¿No tienes cuenta?{" "}
                  <Link to="/registro" className="text-primary-600 fw-semibold">
                    Registrarse
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Modal */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-40 text-center">
              <div className="mb-32">
                <img src="assets/images/auth/envelop-icon.png" alt="" />
              </div>
              <h6 className="mb-12 text-primary-600">Verifica tu correo electrónico</h6>
              <p className="text-secondary-light text-sm mb-0">
                Gracias, revise su correo electrónico para obtener instrucciones para restablecer su contraseña
              </p>
              <button
                type="button"
                className="btn btn-primary-50 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPasswordLayer;